import { Pages } from "@constants/pages/Pages";
import { ApplicationPermissionsModel } from "@models/permissions/ApplicationPermissionsModel";
import { DashboardQuickLinkModel } from "../../../shared/models/DashboardQuickLinkModel";
import { ILinkWidgetGeneratorType } from "./../../../shared/interfaces/ILinkWidgetGeneratorType";

export class NavigatorLinkGenerator implements ILinkWidgetGeneratorType {
    getTypes(permissions: ApplicationPermissionsModel, pages: Pages): DashboardQuickLinkModel[] {
        const quickLinks = [];
        if (permissions.HasBDManagementAccess) {
            quickLinks.push({
                title: "linkWidget.businessDimensionsTitle",
                icon: "fad fa-building",
                page: pages.NavBusinessDimension,

                description: "linkWidget.businessDimensionsDescription",
            });
        }

        if (permissions.HasFDManagementAccess) {
            quickLinks.push({
                title: "linkWidget.frameworkDimensionsTitle",
                icon: "fad fa-object-group",
                page: pages.FrameworkNavigator,

                description: "linkWidget.frameworkDimensionsDescription",
            });
        }

        if (permissions.HasProcessViewerAccess) {
            quickLinks.push({
                title: "linkWidget.processOverviewTitle",
                icon: "fad fa-map",
                page: pages.NavProcessOverview,

                description: "linkWidget.processOverviewDescription",
            });
        }

        if (permissions.HasProcessEditorAccess) {
            quickLinks.push({
                title: "linkWidget.processEditorTitle",
                icon: "fad fa-sitemap",
                page: pages.NavProcessEditor,

                description: "linkWidget.processEditorDescription",
            });
        }

        return quickLinks;
    }
}
